export default "<app-dynamic-content-offers [offerType]=\"DYNAMIC_OFFERS\"></app-dynamic-content-offers>";